import {
    useGetCurrencyConversion,
    useNFTCollectionAssetsFromParams,
    useNFTMainData,
    useReservoirTokensData,
} from '@pkg/hooks';
import { trimDecimals, WEI_CONVERSION_RATE } from '@pkg/utils';

import { type NFTPriceDataTypes } from '@app/pages/NFTDetailView/components/MainStage/components/NFTInfo/NFTInfo.data';

type Price = NFTPriceDataTypes & { expiration?: Date };

export const BID_LABEL = 'bid';
export const ASK_LABEL = 'list';

// TODO - remove this whole hook when we can use V2 for offers, estimations, & token type
export const useNFTInfoData = () => {
    const { data: rawData } = useNFTMainData();
    const { data: collectionAssetsData } = useNFTCollectionAssetsFromParams();
    const { data: collectionData } = useReservoirTokensData();
    const { data: conversionData } = useGetCurrencyConversion({ interval: true });

    const prices: Price[] = [];

    const { decimal: topBidEth, usd: topBidUsd } = collectionData?.tokens?.[0]?.market?.topBid?.price?.amount || {};
    const { validUntil } = collectionData?.tokens?.[0]?.market?.topBid || {};

    const appraisal = collectionAssetsData?.appraisal;
    const traitsData = collectionAssetsData?.traits;
    const ask = collectionData?.tokens?.[0]?.market.floorAsk;
    const conversionValue = conversionData?.ethereum?.usd || 0;

    if (ask?.price) {
        const currentValue = parseFloat(ask.price.amount.raw || '0');
        const eth = trimDecimals(currentValue / WEI_CONVERSION_RATE, 4);
        const usd = trimDecimals(conversionValue * eth || ask.price.amount.usd || 0);

        const currentPrice = {
            label: ASK_LABEL,
            price: usd,
            number: eth,
            percent: 0,
        };

        prices.push(currentPrice);
    }

    if (appraisal && appraisal.wei && !ask) {
        const currentValue = parseFloat(appraisal.wei || '0');
        const eth = trimDecimals(currentValue / WEI_CONVERSION_RATE, 4);
        const usd = trimDecimals(conversionValue * eth || appraisal.usd || 0);
        const currentPrice = {
            label: 'current',
            price: usd,
            number: eth,
            percent: 0,
        };
        if (collectionAssetsData.last_sale) {
            const lastSaleValue = parseFloat(collectionAssetsData.last_sale.wei);
            const percentChange = (currentValue * 100) / lastSaleValue - 100;
            currentPrice.percent = trimDecimals(percentChange);
        }
        prices.push(currentPrice);
    }

    // TODO; Do we need % change on bid?
    if (topBidEth) {
        const eth = trimDecimals(topBidEth, 4);
        const usdConverted = conversionValue * eth;
        const usd = trimDecimals(usdConverted || topBidUsd || 0);
        prices.push({
            label: BID_LABEL,
            price: usd,
            number: eth,
            expiration: validUntil ? new Date(validUntil * 1000) : undefined,
            percent: 0,
        });
    }

    const bought_at = (collectionAssetsData?.last_sale?.timestamp || 0) * 1000;
    const owner = collectionData?.tokens?.[0]?.token?.owner;

    // TODO replace all with v2
    return {
        bought_at: bought_at ? new Date(bought_at).toLocaleDateString('en-US') : '',
        token_type: rawData?.token_type,
        prices,
        owner,
        traitsData,
    };
};
